import { Button } from "antd";
import Image from "next/image";
import Link from "next/link";
import { BlocWrapper } from "./Bloc.style";

export default function Bloc({
  title,
  btn,
  img,
  children,
  className,
  isDesktop,
  reverse = false,
}) {
  return isDesktop ? (
    <BlocWrapper className={reverse ? "reverse" : ""}>
      <div className={"imageWrapper " + className} data-aos="fade-up">
        <Image
          src={img}
          layout="fill"
          objectFit="contain"
          placeholder="blur"
          priority
        />
      </div>
      <div className={"contentWrapper"} data-aos="fade-up">
        {title}
        <div className="content">{children}</div>
        {btn && (
          <div className="btn">
            <Button>
              <Link href="/start">{btn}</Link>
            </Button>
          </div>
        )}
      </div>
    </BlocWrapper>
  ) : (
    <BlocWrapper>
      <div className={"contentWrapper"}>
        <div className="title">{title}</div>
        <div className="content">{children}</div>
        {btn && (
          <div className="btn">
            <Button>
              <Link href="/start">{btn}</Link>
            </Button>
          </div>
        )}
      </div>
    </BlocWrapper>
  );
}
